<ng-container *ngIf="slide">
  <div class="slide-wrapper">
    <img
      class="slide-image"
      [src]="slide.image?.data?.attributes?.url"
      alt="SLide image"
    />
    <h2>
      {{ slide.title }}
    </h2>
    <p>
      {{ slide.description }}
    </p>
    <a class="carousel-slide-button" [href]="slide.route ?? slide.link">
      {{ slide.button_text }}
      <img src="assets/icons/carousel-arrow-right.svg" />
    </a>
  </div>
</ng-container>
